import { IsArray, IsBoolean, IsDefined, IsNumber, IsString } from "class-validator";

export class RouteInfo {
    @IsDefined()
    @IsString()
    public _id: string;

    @IsDefined()
    @IsString()
    public originLocationMachineName: string;

    @IsDefined()
    @IsString()
    public destinationLocationMachineName: string;
}

export class PreviewDeleteLocationResult {
    @IsDefined()
    @IsBoolean()
    public canBeDeleted: boolean;

    @IsDefined()
    @IsNumber()
    public usedByRoutesCount: number;

    @IsDefined()
    @IsNumber()
    public usedByOrdersCount: number;

    @IsDefined()
    @IsNumber()
    public usedByDriversCount: number;

    @IsDefined()
    @IsNumber()
    public usedByDriverCompaniesCount: number;

    @IsDefined()
    @IsArray()
    public routes: RouteInfo[];

    @IsDefined()
    @IsArray()
    public orderIds: string[];

    @IsDefined()
    @IsArray()
    public driverIds: string[];

    @IsDefined()
    @IsArray()
    public driverCompanyIds: string[];
}
